import { SVGProps } from 'react'

export const Message = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" fill="none" viewBox="0 0 37 36" {...props}>
    <rect width="36" height="36" x="0.94" fill="currentColor" fillOpacity="0.08" rx="18"></rect>
    <path
      fill="currentColor"
      d="M25.607 9.666H12.274c-.917 0-1.658.75-1.658 1.667l-.009 15L13.941 23h11.666c.917 0 1.667-.75 1.667-1.667v-10c0-.917-.75-1.667-1.667-1.667zm-2.5 10h-8.333a.836.836 0 01-.833-.833c0-.458.375-.833.833-.833h8.333c.459 0 .834.375.834.833a.836.836 0 01-.834.834zm0-2.5h-8.333a.836.836 0 01-.833-.833c0-.458.375-.833.833-.833h8.333c.459 0 .834.375.834.833a.836.836 0 01-.834.834zm0-2.5h-8.333a.836.836 0 01-.833-.833c0-.458.375-.833.833-.833h8.333c.459 0 .834.375.834.833a.836.836 0 01-.834.833z"
    ></path>
  </svg>
)
